import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { UserService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetUserTypesResolver implements Resolve<any> {

  constructor(private userService: UserService) { }

  resolve() {
    return this.userService.getUserTypes();
  }
}
